// Language is auto-detected from the browser once at load and never toggled
// (per design). `ja*` -> Japanese UI, everything else -> English. The API Docs
// page ignores this and is always English.
export const lang =
  typeof navigator !== 'undefined' && /^ja/i.test(navigator.language || '')
    ? 'ja'
    : 'en';

// t('English', '日本語') -> the string for the active language.
export const t = (en, ja) => (lang === 'ja' ? ja : en);
